import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	user__all: 'mw/admin/user/all',
	user__sync: 'mw/admin/user/sync',
	user__space__list: 'mw/admin/user/space/list',
};

export const userApi = createApi({
	reducerPath: 'mw/admin/userApi',

	endpoints: (builder) => ({
		userAll: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/user/all',
				body,
				jsonType: true,
			}),
			providesTags: [tags.user__all],
		}),
		searchUsers: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/user/all',
				body,
				jsonType: true,
			}),
			providesTags: [tags.user__all],
		}),
		userSync: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/user/sync?${qs.stringify(body)}`,
			}),
			providesTags: [tags.user__sync],
		}),
		userSpaceList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/user/space/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.user__space__list],
		}),
	}),
});

export const {
	userAll,
	searchUsers,
	userSync,
	userSpaceList,
} = userApi.endpoints;

export default userApi;
